import React from "react";
import "../css/privacy-policy.css";

const sections = [
  {
    title: "Website Purpose",
    body: [
      "The Cling website is provided for informational, promotional, and brand-related purposes. Cling™ is a product of ClubIn Platforms Pvt. Ltd., an India-based company. The website may include information about Cling, its services, communities, businesses, offers, events, and related content.",
    ],
  },
  {
    title: "Permitted Use",
    body: ["You may use this website only for lawful purposes and in accordance with these Terms. You agree not to:"],
    bullets: [
      "use the website in any way that violates applicable law",
      "interfere with the website’s operation or security",
      "attempt to gain unauthorized access to any part of the website or its systems",
      "copy, scrape, reproduce, republish, or distribute website content except as permitted by law or with prior written permission",
      "introduce malicious code, harmful material, or disruptive activity",
    ],
  },
  {
    title: "Intellectual Property",
    body: [
      "All website content, including text, graphics, branding, logos, layout, design elements, and other materials, is owned by or licensed to ClubIn Platforms Pvt. Ltd. and is protected by applicable intellectual property laws. Except as expressly permitted, you may not copy, modify, distribute, display, publish, or create derivative works from website materials without prior written permission.",
    ],
  },
  {
    title: "Informational Content",
    body: [
      "The website content is provided for general informational purposes only. While Cling may update the website from time to time, Cling does not guarantee that any website content is accurate, complete, current, or free from errors.",
    ],
  },
  {
    title: "Third-Party Links",
    body: [
      "The website may contain links to third-party websites, platforms, or services for convenience or reference. Cling does not control and is not responsible for the content, policies, or practices of third-party sites.",
    ],
  },
  {
    title: "Disclaimer",
    body: [
      'This website is provided on an "as is" and "as available" basis. To the fullest extent permitted by law, Cling disclaims all warranties, express or implied, including warranties of availability, accuracy, non-infringement, merchantability, and fitness for a particular purpose.',
    ],
  },
  {
    title: "Limitation of Liability",
    body: [
      "To the fullest extent permitted by law, ClubIn Platforms Pvt. Ltd. and its affiliates, officers, employees, and partners will not be liable for any indirect, incidental, consequential, special, or punitive damages, or for any loss arising out of or related to your use of or inability to use the website.",
    ],
  },
  {
    title: "Changes to the Website",
    body: [
      "Cling may modify, suspend, or discontinue any part of the website at any time without notice.",
    ],
  },
  {
    title: "Changes to These Terms",
    body: [
      "Cling may update these Terms from time to time. Updated Terms will become effective when posted on the website unless otherwise stated. Continued use of the website after changes are posted means you accept the revised Terms.",
    ],
  },
  {
    title: "Separate App Terms",
    body: [
      "If you use the Cling mobile app or other Cling services with additional functionality, your use of those services may be governed by separate or additional terms, privacy disclosures, or policies.",
    ],
  },
  {
    title: "Governing Law",
    body: [
      "These Terms are governed by the laws of the jurisdiction in which ClubIn Platforms Pvt. Ltd. is established, unless applicable law requires otherwise.",
    ],
  },
  {
    title: "Contact",
    body: [
      "If you have questions about these Terms, please contact ClubIn Platforms Pvt. Ltd., the India-based company operating Cling™, using the contact details provided on the website.",
    ],
  },
];

const WebsiteTermsOfUse = () => {
  return (
    <div className="legal-document">
      <div className="legal-document__hero">
        <p className="legal-document__eyebrow">Website Terms of Use</p>
        <h1>Terms of Use for www.clingsocial.com</h1>
        <p className="legal-document__meta">Effective Date: August 2, 2026</p>
        <p className="legal-document__lead">
          Welcome to Cling. These Terms of Use govern your access to and use of the website
          located at www.clingsocial.com and any related web pages operated by ClubIn Platforms
          Pvt. Ltd., an India-based company. Cling™ is the brand experience provided through that
          company. By accessing or using this website, you agree to these Terms.
        </p>
      </div>

      <div className="legal-document__sections">
        {sections.map((section) => (
          <section className="legal-document__section" key={section.title}>
            <h2>{section.title}</h2>
            {section.body?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.bullets ? (
              <ul>
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
      </div>
    </div>
  );
};

export default WebsiteTermsOfUse;
